import userAccess from "../../userAccess";

// Only accounts roles (Super Admin, Account Admin, Accounts User) holding an
// approval permission may approve/reject; franchisee/upper-management are requesters, not approvers.
export const canApproveAccounts = () =>
  userAccess.isAccountsUserRole() &&
  (userAccess.isAccountsReceivable() ||
    userAccess.isAccountDeptAdmin() ||
    userAccess.isSystemAdmin());
